module OhoOfficeFactory
{
	export function GetCitiesByState(state: States, successCallback: (Cities: string[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state
		};
		$.ajax("/Api/SocialSecurity/Offices/Oho/GetOhoOfficeCitiesByState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}

	export function GetOhoOfficesByStateCity(state: States, city: string, successCallback: (OhoOffices: IOhoOffice[]) => any, failureCallback: () => any)
	{
		const parameters = {
			state: state,
			city: city
		};
		$.ajax("/Api/SocialSecurity/Offices/Oho/GetOhoOfficesByCityState", {
      data: $.param(parameters),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      timeout: 5000,
      success: successCallback,
      error: failureCallback
    });
	}
}